import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

@Component({
  template: require('./library-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class LibraryPage extends vue {
  // Preloader
  get loading() {
    return this.$store.state.loadingUser;
  }
}